import { render } from "./ViewCreancePage.vue?vue&type=template&id=76fb99ff&ts=true"
import script from "./ViewCreancePage.vue?vue&type=script&lang=ts"
export * from "./ViewCreancePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__